import { ReactNode } from 'react';

import { ReactComponent as Home } from "assets/SidebarIcons/home.svg";
import { ReactComponent as Radar } from "assets/SidebarIcons/radar.svg";
import { ReactComponent as AddressBook } from "assets/SidebarIcons/addressbook.svg";
import { ReactComponent as EveryUser } from "assets/SidebarIcons/everyuser.svg";
import { ReactComponent as Peoples } from "assets/SidebarIcons/peoples.svg";
import { ReactComponent as PeoplesSafe } from "assets/SidebarIcons/peoplesafeone.svg";
import { ReactComponent as Delivery } from "assets/SidebarIcons/delivery.svg";
import { ReactComponent as All } from "assets/SidebarIcons/allapplication.svg";
import { ReactComponent as Map } from "assets/map1.svg";
import { ReactComponent as Monitor } from "assets/SidebarIcons/monitor.svg";
import { ReactComponent as TreeList } from "assets/SidebarIcons/treelist.svg";
import { ReactComponent as Payments } from "assets/SidebarIcons/payments.svg";
import { ReactComponent as Manual } from "assets/SidebarIcons/manualIcon.svg";
import { ReactComponent as Wrench } from "assets/SidebarIcons/wrench.svg";

interface NavbarRoute {
  location: string;
  tooltipLabel: string;
  icon: ReactNode;
  restrictedTo?: string;
}

export const sidebarRoutes: NavbarRoute[] = [
  {
    location: '/home',
    tooltipLabel: 'Dashboard',
    icon: <Home />
  },
  {
    location: '/monitor',
    tooltipLabel: 'Monitor de Ocorrências',
    icon: <Monitor />
  },
  {
    location: '/maintenance',
    tooltipLabel: 'Manutenção',
    icon: <Wrench />
  },
  {
    location: '/map',
    tooltipLabel: 'Mapa',
    icon: <Map />
  },
  {
    location: '/clients',
    tooltipLabel: 'Clientes',
    icon: <AddressBook />
  },
  {
    location: '/sub-clients',
    tooltipLabel: 'Sub-clientes',
    icon: <EveryUser />
  },
  {
    location: '/users',
    tooltipLabel: 'Usuários',
    icon: <Peoples />
  },
  {
    location: '/policemen',
    tooltipLabel: 'Agentes',
    icon: <PeoplesSafe />
  },
  {
    location: '/providers',
    tooltipLabel: 'Fornecedores',
    icon: <Delivery />
  },
  {
    location: '/occurrences',
    tooltipLabel: 'Histórico de Ocorrências',
    icon: <Radar />
  },
  {
    location: '/manual',
    tooltipLabel: 'Manual de uso',
    icon: <Manual />
  }
]